import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './img-filter.scss?inline';

export default class SotbitImgFilter extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        src: { type: String },
    };

    constructor() {
        super();

        this.src = null;
    }

    render() {
        return html` <div class="img-wrapper">
            ${this.src
                ? html`<img loading="lazy" src="${this.src}" />`
                : html` <sotbit-icon class="icon" size="m" variant="simple" icon="no-photo-product"></sotbit-icon>`}
        </div>`;
    }
}
